import styled from "styled-components"

export const PoiModal = styled.div`
  z-index: 2000;
  left: 50%;
  /* border: blue solid 2px; */
  display: flex;
  justify-content: center;
  bottom: 50%;
  transform: translate(-50%, 50%);
  position: absolute;
  height: 78vh;
  width: max-content;
`
